import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { HistoryFilters } from '../../model/history-filters';

@Component({
  selector: 'app-call-filters',
  templateUrl: './call-filters.component.html',
  styleUrls: ['./call-filters.component.scss'],
})
export class CallFiltersComponent {
  @Input()
  type!: 'call' | 'message';

  @Output()
  closeSidenav: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  selectedFilters: EventEmitter<HistoryFilters> = new EventEmitter<HistoryFilters>();

  nameOrNumber = new FormControl();
  duration = new FormGroup({
    min: new FormControl(null),
    max: new FormControl(null),
  });
  dateRange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  status = new FormGroup({
    initiated: new FormControl(),
    successful: new FormControl(),
    error: new FormControl(),
    missed: new FormControl(),
    delivered: new FormControl(),
    undelivered: new FormControl(),
  });

  close() {
    this.closeSidenav.emit();
  }

  reset() {
    this.nameOrNumber.reset();
    this.duration.reset();
    this.dateRange.reset();
    this.status.reset();
  }

  onKey(event: any, from: string) {
    if (from === 'min') {
      const min = this.duration.get<string>('min');
      if (min?.value.length === 2) {
        min.setValue(min.value + 'm');
      }
      if (min?.value.length === 5) {
        min.setValue(min.value + 's');
      }
      if ((min?.value.length === 3 || min?.value.length === 6) && event.key === 'Backspace') {
        min.setValue(min.value.toString().slice(0, -2));
      }
    }
    if (from === 'max') {
      const max = this.duration.get<string>('max');
      if (max?.value.length === 2) {
        max.setValue(max.value + 'm');
      }
      if (max?.value.length === 5) {
        max?.setValue(max.value + 's');
      }
      if ((max?.value.length === 3 || max?.value.length === 6) && event.key === 'Backspace') {
        max.setValue(max.value.toString().slice(0, -2));
      }
    }
  }

  apply() {
    const filters: HistoryFilters & { status: string[] } = {
      nameOrNumber: this.nameOrNumber.value,
      duration: {
        min: this.cleanDuration(this.duration.get<string>('min')?.value),
        max: this.cleanDuration(this.duration.get<string>('max')?.value),
      },
      status: [],
      dateRange: {
        start: this.dateRange.get<string>('start')?.value,
        end: this.dateRange.get<string>('end')?.value,
      },
      type: this.type,
    };

    if (this.status.get('initiated')?.value) {
      filters.status.push('initiated');
    }

    if (this.status.get('successful')?.value) {
      filters.status.push('successful');
    }

    if (this.status.get('missed')?.value) {
      filters.status.push('missed');
    }

    if (this.status.get('error')?.value) {
      filters.status.push('error');
    }

    if (this.status.get('delivered')?.value) {
      filters.status.push('delivered');
    }

    if (this.status.get('undelivered')?.value) {
      filters.status.push('undelivered');
    }

    this.selectedFilters.emit(filters);

    this.close();
  }

  cleanDuration(duration: string) {
    if (duration && duration !== '') return duration.replace('m', '').replace('s', '');
    return null;
  }
}
